// Campos que autoCompleteContribution() rellena solo (incumplimientos UY VIP, persona y empresa).
// No deben forzarse a editable=true en alta: se respeta el editable que viene del configurador.
export const vipUyContributionAutoFields = [
  'afiliado',
  'sucursal',
  'numero_documento',
  'rut',
  'pais_documento',
  'primer_nombre',
  'primer_apellido',
  'razon_social',
  'tipo_documento'
];

